/**
 * Helper that based on a condition returns the found element or document.body
 * @param condition {boolean}
 * @param id {string} - ID of an element
 * @returns {HTMLElement} - the found element or document.body
 */
export function getElementOrBody(condition, id) {
    return condition && document.getElementById(id) || document.body;
}
//# sourceMappingURL=getElementOrBody.js.map